import { put, takeLatest, call } from 'redux-saga/effects';
import Pagination from '../interfaces/common/pagination';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import { PayloadAction } from '@reduxjs/toolkit';
import Paging from '../interfaces/common/paging';
import { fetchYesNoByIdError, fetchYesNoByIdSuccess, fetchYesNoError, fetchYesNoSuccess } from '../reducers/yesNoReducer';
import YesNo from '../interfaces/output/YesNo';
import YesNoApi from '../api/yesNoApi';

function* doFetchYesNoById(action: PayloadAction<string>) {
    const yesNoId = action.payload;
    try {
        const response: YesNo = yield call(YesNoApi.fetchYesNoById, yesNoId);
        yield put(fetchYesNoByIdSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchYesNoByIdError(error as HttpErrorResponse));
    }
}

function* doFetchYesNo(action: PayloadAction<{ paging: Paging}>) {
    const { paging } = action.payload;
    try {
        const response: Pagination<YesNo> = yield call(YesNoApi.fetchYesNo, paging);
        yield put(fetchYesNoSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchYesNoError(error as HttpErrorResponse));
    }
}

export default [
    takeLatest('yesNo/fetchYesNoById', doFetchYesNoById),
    takeLatest('yesNo/fetchYesNo', doFetchYesNo)
];

